import { useIntl } from 'react-intl'
import Typography from '../../../../Typography/Typography'

import './TicketTypes.scss'

const TicketTypes = () => {
    const intl = useIntl()

    const ticketTypes = [
        {
            type: intl.formatMessage({ id: 'windows.info.ticketTypes.type.child' }),
            description: intl.formatMessage({ id: 'windows.info.ticketTypes.description.child' }),
        },
        {
            type: intl.formatMessage({ id: 'windows.info.ticketTypes.type.student' }),
            description: intl.formatMessage({ id: 'windows.info.ticketTypes.description.student' }),
        },
        {
            type: intl.formatMessage({ id: 'windows.info.ticketTypes.type.senior' }),
            description: intl.formatMessage({ id: 'windows.info.ticketTypes.description.senior' }),
        },
        {
            type: intl.formatMessage({ id: 'windows.info.ticketTypes.type.ztp' }),
            description: intl.formatMessage({ id: 'windows.info.ticketTypes.description.ztp' }),
        },
    ]

    return (
        <>
            {ticketTypes.map(({ type, description }) => (
                <div key={type} className={'tickets-type d-flex'}>
                    <Typography variant={'label'} color={'lighterPrimary'}>
                        {type}
                    </Typography>
                    <Typography variant={'p'} className={'w-100'}>
                        {description}
                    </Typography>
                </div>
            ))}
        </>
    )
}

export default TicketTypes
